import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpTokenInterceptor } from './http.token.interceptor';
import { BasicAuthInterceptor } from './basic-auth.interceptor';
import { LoadingInterceptor } from './loading.interceptor';
import { HashInterceptor } from './hash.interceptor';

export const MyInterceptors = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: BasicAuthInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpTokenInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HashInterceptor,
    multi: true,
  },
];
